const componentClassName = (name) => {
  return name.charAt(0).toLowerCase() + name.slice(1);
};

const componentFileName = (name) => {
  return name.toLowerCase() === 'calculated' ? 'Calculated' : name;
};

export {
  componentClassName,
  componentFileName
};
